import { render } from "./AddEditShippingmethod.vue?vue&type=template&id=526a2a76"
import script from "./AddEditShippingmethod.vue?vue&type=script&lang=js"
export * from "./AddEditShippingmethod.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__